angular.module('angus.controllers').controller('alertResultsSettingsController', [
    '$scope',
    function ($scope) {

    }
]);